import {useFirstNotCompletedAction} from '@/hooks/loyalty/dataHooks';
import {hideNextJourneyLevelTaskPopup} from '@/state/slices/modalSlice';
import {dispatch} from '@/state/store';
import {NextTaskPopupTemplate} from '@/views/Loyalty/PopupTemplates';

import LoyaltyModalPopup from './LoyaltyModalPopup';

const NextTaskPopup = ({actionId}) => {
    // TODO: Remove. Temporary logic for testing
    const action = useFirstNotCompletedAction();

    const handleClose = () => {
        dispatch(hideNextJourneyLevelTaskPopup());
    };

    return (
        <LoyaltyModalPopup>
            <NextTaskPopupTemplate levelAction={action} onClose={handleClose} onAction={handleClose} />
        </LoyaltyModalPopup>
    );
};

export default NextTaskPopup;
